import { Field, FieldArray, useField } from "formik";
import React, { useState, useRef } from "react";
import BaseElement from "components/FormElements/BaseElement";
import TokenButton from "components/Buttons/TokenButton";

export default function TokenInput(props) {
    const defaultProps = {
        label: "Tokeninput",
        id: "token-input",
        name: "token-input",
        type: "text",
        autoComplete: "off",
        value: [],
        isError: false,
        errorText: "",
        variant: false,
        tokenSeparator: ",",
        filter: (part) => part,
        onChange: () => {},
    };

    const useProps = Object.assign(defaultProps, {}, props);
    // const [field, meta] = useField(props);
    const [field, meta] = useField(useProps);
    const [token, setToken] = useState(null);
    const itemRef = useRef(null);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    // parse and filter input string, returns array of tokens
    const parseInput = (value, arrayHelpers) => {
        const parts = value
            .split(useProps.tokenSeparator)
            .map((part) => part.trim())
            .filter(useProps.filter);

        if (parts.length === 0) {
            return;
        }

        return parts;
    };

    // append a single token
    const appendToken = (value, arrayHelpers) => {
        const existing = field.value.find((item) => item === value);
        setToken(null);
        if (existing) {
            return;
        }
        arrayHelpers.push(value);
        return;
    };

    const input = (
        <div>
            <FieldArray
                name={field.name}
                render={(arrayHelpers) => (
                    <div>
                        <div className="relative mt-1 mb-2 rounded-md">
                            <input
                                type="text"
                                name="auto_complete_token"
                                ref={itemRef}
                                autoComplete="off"
                                className="block w-full rounded-md border-gray-300 pr-10 focus:border-green-500 focus:ring-green-500 sm:text-sm"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && token) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        appendToken(token, arrayHelpers);
                                        itemRef.current.value = "";
                                        return false;
                                    }
                                }}
                                onKeyUp={(e) => {
                                    setToken(null);
                                    if (e.key === "Meta") {
                                        return;
                                    }
                                    const values = parseInput(
                                        e.target.value,
                                        arrayHelpers
                                    );
                                    if (!values || values.length === 0) {
                                        return;
                                    }
                                    setToken(values[0]);
                                }}
                                onPaste={(e) => {
                                    const values = parseInput(
                                        e.clipboardData.getData("text"),
                                        arrayHelpers
                                    );
                                    if (!values || values.length === 0) {
                                        return;
                                    }
                                    values.forEach((value) =>
                                        appendToken(value, arrayHelpers)
                                    );
                                    setTimeout(() => {
                                        itemRef.current.value = "";
                                    }, 100);
                                }}
                            />
                        </div>
                        <div className="relative max-w-full">
                            <ul className="absolute top-0 left-0 min-w-full overflow-auto bg-white shadow">
                                {token ? (
                                    <li
                                        className="cursor-pointer bg-gray-100 px-6 py-2"
                                        onClick={(e) =>
                                            appendToken(token, arrayHelpers)
                                        }
                                    >
                                        <span className="text-sm font-light text-gray-700">
                                            {token}
                                        </span>
                                    </li>
                                ) : (
                                    ""
                                )}
                            </ul>
                        </div>
                        {field.value.map((val, idx) => (
                            <div
                                key={idx}
                                onClick={() => arrayHelpers.remove(idx)}
                                className="mr-1 inline-flex"
                            >
                                <Field
                                    name={`${field.name}[${idx}]`}
                                    value={val}
                                    className="hidden"
                                />
                                <TokenButton label={val} />
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        useProps.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {useProps.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...useProps}
            label={label}
            input={input}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}
